export default __webpack_public_path__ + "static/media/KeyPlan.67849004.png";